(function($) {

	'use strict';

	function init(){
		buildMarkers();
		initMap();
		initClusterer();
		initSpiderfier();
		initMarkers();
		$('.listAdherents__content__switcher').on('click', switchListMap);
		$('.listAdherents__content__switcher__focus').on("animationend", endAnimation);
	}

	function endAnimation(){
		$('.listAdherents__content__switcher__focus').css('animation', false);
	}

	function switchListMap(){
		let wrapper = $('.listAdherents__content__wrapper');
		$('.listAdherents__content__switcher__focus').css('animation', "squish .3s forwards");
		wrapper.attr( 'data-active', ( wrapper.attr('data-active')=='map' ) ? 'list' : 'map' );
		$('.listAdherents__content__switcher__item img, .listAdherents__content__map, .listAdherents__content__list').toggleClass('active');
	}
	
	function buildMarkers(){
		// Un seul objet InfoWindow pour éviter l'ouverture de plusieurs InfoWindow en meme temps
		GMAP_CI.infoWindow = new google.maps.InfoWindow();

		// Creation des objets Market et evenet d'ouverture d'InfoWindow avec le contenu associé
		$.each(GMAP_CI.markersData, function(index, markerItem) {
			let marker = new google.maps.Marker({
				position	: new google.maps.LatLng(
					markerItem.lat,
					markerItem.lng
				),
				icon		: {
					url			: markerItem.iconUrl,
					scaledSize	: new google.maps.Size(40, 47),
					anchor		: new google.maps.Point(20, 36),
				}
			});

			// Evenement 'spider_click' pour éviter l'ouverture de l'infoWindow lors du clic sur un cluster
			google.maps.event.addListener(marker, 'spider_click', function() {
				if( window.innerWidth < 992 ){
					//Mobile event : ouvre une infowindow custom en dehors de la googlemap et ferme l'infowindow de la map par précaution
					GMAP_CI.infoWindow.close();
					activeMarkerList(markerItem.id);
				} else {
					//Desktop event : mets à jour le contenu de l'infowindow de la map et ouvre la
					GMAP_CI.infoWindow.setContent(markerItem.infoWindow);
					GMAP_CI.infoWindow.open(GMAP_CI.map, marker);
				}
			});
				
			GMAP_CI.markers.push(marker);
		});
	}

	function activeMarkerList(id){
		$('.listAdherents__adherentCard').removeClass('active');
		$('#adherentCard-'+id).addClass('active');
	}

	function initMap() {
		// Initialisation de la map
		GMAP_CI.map = new google.maps.Map($('.listAdherents__content__map')[0], {
			zoom				: 8,
			center				: new google.maps.LatLng(48.1721196, -2.5141578),
			mapTypeId			: google.maps.MapTypeId.ROADMAP,
			zoomControl			: true,
			mapTypeControl		: false,
			scaleControl		: false,
			streetViewControl	: false,
			rotateControl		: false,
			fullscreenControl	: false,
			clickableIcons		: false
		});
	}

	function initClusterer(){
		// Initialisation du Clusterer
		GMAP_CI.clusterer = new MarkerClusterer(GMAP_CI.map, [], {
			maxZoom		: 14,
			gridSize	: 50,
			styles		: [
				MarkerClusterer.withDefaultStyle({
					width		: 58,
					height		: 71,
					url			: GMAP_CI.templateUrl+"/images/map_pin_default.svg",
					textColor	: "#182062",
					textSize	: 16,
					anchorText	: [-10, 0],
				})
			],
		});
	}

	function initSpiderfier(){
		// Initialisation du Spiderfier
		GMAP_CI.oms = new OverlappingMarkerSpiderfier(GMAP_CI.map, { 
			markersWontMove		: true,
			markersWontHide		: true,
			basicFormatEvents	: true
		});
	}

	function initMarkers(){
		// Close infowindow event on map click
		google.maps.event.addListener(GMAP_CI.map, 'click', function(){
			GMAP_CI.infoWindow.close();
		});
		
		// Close infowindow event on close buttton
		$('.listAdherents__content__map').on('click', function(e){
			if(window.innerWidth >= 992){
				if( $(e.target).hasClass('listAdherents__adherentCard__close') ){
					GMAP_CI.infoWindow.close();
				}
			}
		});

		$('.listAdherents__adherentCard__close').on('click', function(e){
			if(window.innerWidth < 992){
				e.stopPropagation()
				$('.listAdherents__adherentCard.active').removeClass('active');
			}
		})

		// Add markers object to clusterer and spiderfier
		$.each(GMAP_CI.markers, function(i, marker){
			GMAP_CI.oms.addMarker(marker);
			GMAP_CI.clusterer.addMarker(marker);
		});
	}

	$(document).ready(function() {
		if($('.listAdherents__content__map').length){
			init();
		}
	});

})(jQuery);
